import type { IconSvgProps } from '../Icon.types';

export const CheckSimple = ({ width, height }: IconSvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 256 256">
    <polyline
      points="40 144 96 200 224 72"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);
